import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { motion, useInView } from "framer-motion";
import {
  SiVisualstudiocode,
  SiPostman,
  SiOracle,
  SiEclipseide,
  SiMysql,
  SiAmazonaws,
  SiIntellijidea,
  SiPycharm,
  SiApachejmeter,
  SiGit,
  SiDocker,
  SiKubernetes,
  SiHelm,
  SiJenkins,
  SiTerraform,
  SiApachemaven,
  SiAnaconda,
  SiJfrog,
  SiSplunk,
  SiGithub,
  SiGitlab,
  SiBitbucket,
} from "react-icons/si";

const toolItems = [
  { icon: <SiVisualstudiocode />, name: "VS Code" },
  { icon: <SiPostman />, name: "Postman" },
  { icon: <SiOracle />, name: "Oracle" },
  { icon: <SiEclipseide />, name: "Eclipse" },
  { icon: <SiMysql />, name: "MySQL" },
  { icon: <SiAmazonaws />, name: "AWS" },
  { icon: <SiIntellijidea />, name: "IntelliJ" },
  { icon: <SiPycharm />, name: "PyCharm" },
  { icon: <SiApachejmeter />, name: "JMeter" },
  { icon: <SiGit />, name: "Git" },
  { icon: <SiDocker />, name: "Docker" },
  { icon: <SiKubernetes />, name: "Kubernetes" },
  { icon: <SiHelm />, name: "Helm" },
  { icon: <SiJenkins />, name: "Jenkins" },
  { icon: <SiTerraform />, name: "Terraform" },
  { icon: <SiApachemaven />, name: "Maven" },
  { icon: <SiAnaconda />, name: "Anaconda" },
  { icon: <SiJfrog />, name: "JFrog" },
  { icon: <SiSplunk />, name: "Splunk" },
  { icon: <SiGithub />, name: "GitHub" },
  { icon: <SiGitlab />, name: "GitLab" },
  { icon: <SiBitbucket />, name: "Bitbucket" },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30, scale: 0.9 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      delay: i * 0.05,
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  }),
};

const Toolstack = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  return (
    <Row
      ref={ref}
      style={{ justifyContent: "center", paddingBottom: "50px", paddingTop: "30px" }}
    >
      {toolItems.map((item, index) => (
        <Col xs={4} md={2} key={index} style={{ padding: "8px" }}>
          <motion.div
            className="tech-icons"
            custom={index}
            variants={cardVariants}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            whileHover={{
              y: -6,
              scale: 1.05,
              transition: { type: "spring", stiffness: 400, damping: 15 },
            }}
          >
            {item.icon}
            <span className="tech-icon-label">{item.name}</span>
          </motion.div>
        </Col>
      ))}
    </Row>
  );
};

export default Toolstack;
